/**
 * 加载图片
 * @param {string} url 图片 url
 * @returns {Promise<HTMLImageElement>}
 */
export function loadImage (url) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = function () {
      resolve(image)
    }
    image.onerror = reject
    image.src = url
  })
}
